import * as React from "react";

const IconButtonArrowWhiteLarge: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="9" height="14" viewBox="0 0 9 14" fill="currentColor"><defs><polygon points="2.444 .813 8.844 7.313 2.444 13.813 .844 12.188 5.644 7.313 .844 2.438"/></defs><use xlinkHref="#a" fill="#FFF" fillRule="evenodd"/></svg>;
};

export default React.memo(IconButtonArrowWhiteLarge);
